import { ShopifySearchProvider } from './ShopifySearchProvider';
import { AlgoliaSearchProvider } from './AlgoliaSearchProvider';
import { SearchSpringProvider } from './SearchSpringProvider';
import { BoostSearchProvider } from './BoostSearchProvider';

// Provider mapping
export const SEARCH_PROVIDERS = {
  shopify: ShopifySearchProvider,
  algolia: AlgoliaSearchProvider,
  searchspring: SearchSpringProvider,
  boost: BoostSearchProvider
};

/**
 * Gets the appropriate search provider component based on the provider name
 * 
 * @param {string} providerName - The name of the search provider to use
 * @returns {React.ComponentType} The search provider component
 */
export function getSearchProvider(providerName) {
  const provider = SEARCH_PROVIDERS[providerName?.toLowerCase()];
  
  if (!provider) {
    console.warn(`Search provider '${providerName}' not found, defaulting to Shopify`);
    return ShopifySearchProvider;
  }
  
  return provider;
}

export {
  ShopifySearchProvider,
  AlgoliaSearchProvider,
  SearchSpringProvider,
  BoostSearchProvider
};